import { gql } from '@apollo/client';

export const QUERY_ROLE_BY_PACKAGE_PAGE = gql`
  query QueryRoleByPackagePage($packageId: Long!, $pageRequest: PageRequestTypeInput) {
    queryRoleByPackagePage(packageId: $packageId, pageRequest: $pageRequest) {
      content {
        id
        name
        description
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface RoleByPackageType {
  id: number | string;
  name: string;
  description?: string | null;
}

export interface PageRequestTypeInput {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface RoleByPackagePageResponseType {
  content: RoleByPackageType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface QueryRoleByPackagePageResponse {
  queryRoleByPackagePage: RoleByPackagePageResponseType;
}

export interface QueryRoleByPackagePageVariables {
  packageId: number;
  pageRequest?: PageRequestTypeInput | null;
}
